import { createContext } from 'react';
import { Header } from '../Table';

export interface TableContextType {
  tableId?: string;
  hasScroll?: boolean;
  toggled?: boolean[];
  selected: number[];
  headers?: Header[];
  selectable?: 'all' | 'single';
  selectRow: (rowIndex: number) => void;
  toggleable?: boolean;
  hover?: boolean;
  toggle: (open: boolean, rowIndex: number) => void;
  mini?: boolean;
  density?: boolean;
}

const TableContext = createContext<TableContextType>({
  toggle: () => {},
  selectRow: () => {},
  selected: [],
});

export default TableContext;
